<template>
    <div class="wrapper">

        <div class="menu-wrapper">
            <ul>
                <li v-for="(item, index) in items" :class="{active: activeTabSlug === item.slug}" @click.prevent="activeTabSlug=item.slug">
                    <div class="bar-wrap">
                        <div class="bar"></div>
                    </div>
                    <div class="label">
                        <a href="" v-html="item.name"></a>
                    </div>
                </li>
            </ul>
        </div>
        <div class="tabs-wrapper">
            <transition name="fade-actus-home">
                <div v-if="showTab('actualites')" key="actualites">
                    <slot name="actualites">
                    </slot>
                </div>
            </transition>
            <transition name="fade-actus-home">
                <div v-if="showTab('agenda')" key="agenda">
                    <slot name="agenda">
                    </slot>
                </div>
            </transition>
            <transition name="fade-actus-home">
                <div v-if="showTab('newsletters')" key="newsletters">
                    <slot name="newsletters">
                    </slot>
                </div>
            </transition>
        </div>


    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        data() {
            return {
                items: [],
                activeTabSlug: null,
                forceShowTab: true
            };
        },
        methods: {
            showTab(index) {
                if (this.forceShowTab) {
                    return true
                }
                return this.activeTabSlug === index

            }
        },
        mounted() {
            $(".home-actus .tab").each((index, item) => {

                let className = $(item).attr("class").split(/\s+/);
                this.items.push({
                    name: $(item).data("name"),
                    slug: className[1]
                })

            })
            this.activeTabSlug = this.items[0].slug

            this.forceShowTab = false

        },
        destroyed() {
        }
    };
</script>
